import React from "react";

export const ToolBarMenuSeparator = () => {
  return (
    <div
      style={{
        height: "10px",
        width: "100%",
        borderBottom: "1px solid #F0F2F5",
      }}
    ></div>
  );
};

